import { StorageError } from "@/domain";

export function isQuotaExceededError(error: unknown): boolean {
  if (error instanceof DOMException) {
    return (
      error.name === "QuotaExceededError" ||
      error.name === "NS_ERROR_DOM_QUOTA_REACHED"
    );
  }

  return (
    typeof error === "object" &&
    error !== null &&
    "name" in error &&
    (error.name === "QuotaExceededError" ||
      error.name === "NS_ERROR_DOM_QUOTA_REACHED")
  );
}

export function toStorageWriteError(
  error: unknown,
  operation: string,
): StorageError {
  if (error instanceof StorageError) {
    return error;
  }

  if (isQuotaExceededError(error)) {
    return new StorageError(
      "storage-quota-exceeded",
      "The browser does not have enough local storage for this operation.",
      operation,
      { cause: error },
    );
  }

  return new StorageError(
    "storage-write-failed",
    `Local storage failed while attempting to ${operation}.`,
    operation,
    { cause: error },
  );
}

export function toStorageOpenError(error: unknown): StorageError {
  if (error instanceof StorageError) {
    return error;
  }

  return new StorageError(
    "storage-open-failed",
    "Marginalia could not open its local database.",
    "open the database",
    { cause: error },
  );
}
